import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {ReturnCode} from "@/models";

export class ReturnCodesService {
    static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAllReturnCodes(langCode: string, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<ReturnCode[]>('/api/ReturnCodes', {langCode: langCode}, cancelToken);
    }
}

lazyRegister.service('ReturnCodesService', ReturnCodesService);

